import { GoogleGroupDescription } from '@dadohr/shared/domainTypes/integrations/googleSheets';
import { CF } from '@dadohr/shared/versions';
import { useFirebaseFunction } from '../../../../../../services/firebaseFunctions';
import { ONE_MINUTE } from '../../../../../../services/time';

export const useGroupList = (orgId: string, domain: string) => {
  return useFirebaseFunction<GoogleGroupDescription[]>(
    CF.google.groups.getList,
    { orgId, domain },
    [orgId, domain],
    ONE_MINUTE * 5
  );
};
